export enum EVENT_HISTORY_CATEGORY {
  FAO = 'Fao',
  TRANSACTION = 'Transaction',
  RENTAL = 'Rental',
  SALE = 'Sale',
}
